import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { getData } from "../api/protectedApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handleCopy } from "../utils/handleCopy";
import styles from "./css/selfAddresses.module.css";

import { callDataByEndpoint } from "../utils/dataUtils";

const SelfAddresses = () => {
  const [wallets, setWallets] = useState([]);
  const [copiedText, setCopiedText] = useState(null);

  useEffect(() => {
    showWallets();
  }, []);

  const showWallets = () => {
    callDataByEndpoint("/user/self_address_list", {
      method: "GET",
      setData: setWallets,
    });
  };

  const generateAddress = () => {
    const confirmAction = window.confirm("Are you sure you want to generate a new deposit address?");
    if (confirmAction) {
      getData("/user/generate_self_address")
        .then(() => {
          toast.success("New deposit address generated!");
          showWallets();
        })
        .catch((err) => {
          console.error(err);
          toast.error("Failed to generate address.");
        });
    }
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.headerRow}>
        <div>
          <h2 className={styles.pageTitle}>Self Deposit Addresses</h2>
          <p className={styles.pageSubtitle}>Generate and manage dedicated contract deposit wallets.</p>
        </div>
        <button className={styles.btnGenerate} onClick={generateAddress}>
          <i className="fas fa-plus"></i> Generate New Address
        </button>
      </div>

      <div className={styles.walletGrid}>
        {wallets.map((wallet, index) => {
          const addrAbbr = wallet.walletAddress
            ? `${wallet.walletAddress.slice(0, 10)}...${wallet.walletAddress.slice(-8)}`
            : "N/A";

          return (
            <motion.div
              key={wallet._id || index}
              className={styles.walletCard}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05, type: "spring", stiffness: 100, damping: 15 }}
            >
              <div className={styles.walletHeader}>
                <h5 className={styles.walletTitle}>Deposit Wallet #{index + 1}</h5>
                <i className="fas fa-qrcode text-success fs-5"></i>
              </div>

              <div className={styles.qrContainer}>
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${wallet.walletAddress}`}
                  alt="QR Code"
                  className={styles.qrImage}
                />
              </div>

              <div className={styles.addressBadge} title={wallet.walletAddress}>
                {addrAbbr}
              </div>

              <div className={styles.actionRow}>
                <button
                  type="button"
                  className={styles.btnAction}
                  onClick={() => handleCopy(setCopiedText, wallet.walletAddress)}
                >
                  <i className={`fas ${copiedText === wallet.walletAddress ? "fa-check text-success" : "fa-copy"}`}></i> Copy
                </button>
                <Link
                  className={styles.btnAction}
                  to={`/self_transactions/${wallet.walletAddress}`}
                >
                  <i className="fas fa-history"></i> Check Ledger
                </Link>
              </div>

              <p className={styles.createdText}>
                Created: {new Date(wallet.createdAt).toLocaleString()}
              </p>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default SelfAddresses;